// extracted by mini-css-extract-plugin
module.exports = {"list":"list_list__1QS7r shadow","item":"list_item__1xpiI"};